import {mutationRequest} from "./makePostRequest";

export const mutationUserVerification = (body) => mutationRequest('userVerification', `userVerification`, body);

export default mutationUserVerification;
